
import { Github } from 'lucide-react';

interface NavLogoProps {
  onLogoClick: (e: React.MouseEvent) => void;
}

export function NavLogo({ onLogoClick }: NavLogoProps) {
  return (
    <div className="flex items-center gap-2">
      <a
        href="/"
        onClick={onLogoClick}
        className="flex items-center gap-2"
      >
        <span className="font-bold text-lg md:text-xl tracking-tight text-primary">Cybermonit</span>
      </a>

      <div className="flex items-center ml-3 space-x-2">
        <a
          href="https://github.com/Cybermonit/RSS-Feed"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
          aria-label="GitHub Repository"
        >
          <Github className="h-5 w-5" />
        </a>
        <a
          href="https://www.linkedin.com/company/cybermonit"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
          aria-label="LinkedIn Page"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-5 w-5"
          >
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
            <rect x="2" y="9" width="4" height="12"></rect>
            <circle cx="4" cy="4" r="2"></circle>
          </svg>
        </a>
      </div>
    </div>
  );
}
